/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_CancelInputs */

const en_tx_status_cancel = /** @type {(inputs: Tx_Status_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const id_tx_status_cancel = /** @type {(inputs: Tx_Status_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibatalkan`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Tx_Status_CancelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_cancel = /** @type {((inputs?: Tx_Status_CancelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_CancelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_cancel(inputs)
	return en_tx_status_cancel(inputs)
});